"use strict";

export default function () {
  return {
    restrict: "A",
    template: require("../view/transaction-filter.html"),
    scope: {
      updateScopeFilters: "=myUpdate",
      filter: "=myFilter",
    },
    controller: [
      "$scope",
      "$rootScope",
      "$uibModal",
      "$utils",
      "OperatorService",
      "MunicipalityService",
      "StaffService",
      "OrgService",
      function (
        $scope,
        $rootScope,
        $modal,
        $utils,
        OperatorService,
        MunicipalityService,
        StaffService,
        OrgService
      ) {
        $scope.selectAuthor = selectAuthor;
        $scope.selectManager = selectManager;
        $scope.selectMunicipality = selectMunicipality;
        $scope.selectCoordOrg = selectCoordOrg;
        $scope.selectOiv = selectOiv;
        $scope.apply = apply;
        $scope.cancel = cancel;
        $scope.reset = reset;

        $scope.selectSettings = $rootScope.selectSettings;
        $scope.selectTranslation = $rootScope.selectTranslation;
        $scope.selectEvents = $rootScope.selectEvents;

        $scope.filter = {};
        $scope.localFilter = {
          placeMunicipality: [],
          ...angular.copy($scope.filter),
        };
        $scope.oldFilter = angular.copy($scope.localFilter);

        $scope.municipalities = [];

        load();

        function load() {
          MunicipalityService.api.get(
            {
              filters: [`'status' EQ 'ENABLED'`],
              sorts: ["npp:ASC", "name:ASC"],
            },
            (data) => {
              $scope.municipalities = [
                {
                  id: "none",
                  name: "Не указано",
                },
              ].concat(data._embedded || []);
            }
          );
        }

        function buildFilters() {
          let filters = [];

          if ($scope.localFilter.code) {
            filters.push(`'project.code' EQ '${$scope.localFilter.code}'`);
          }

          if ($scope.localFilter.author) {
            filters.push(
              `'project.author.id' EQ '${$scope.localFilter.author.id}'`
            );
          }

          if ($scope.localFilter.shortName) {
            filters.push(
              `'project.shortName' EQ '${$scope.localFilter.shortName}'`
            );
          }

          if ($scope.localFilter.manager) {
            filters.push(
              `'project.manager.id' EQ '${$scope.localFilter.manager.id}'`
            );
          }

          if (
            Array.isArray($scope.localFilter.placeMunicipality) &&
            $scope.localFilter.placeMunicipality.length
          ) {
            $scope.localFilter.placeMunicipality.map((item) =>
              filters.push(`'project.municipalityOrg.id' EQ '${item.id}'`)
            );
          }

          if ($scope.localFilter.coordOrg) {
            filters.push(
              `'project.coordorg.id' EQ '${$scope.localFilter.coordOrg.id}'`
            );
          }

          if ($scope.localFilter.oiv) {
            filters.push(`'project.oiv.id' EQ '${$scope.localFilter.oiv.id}'`);
          }

          return filters;
        }

        function selectAuthor() {
          OrgService.select($scope.localFilter.author).result.then(function (
            data
          ) {
            $scope.localFilter.author = data;
          });
        }

        function selectManager() {
          StaffService.select($scope.localFilter.manager).result.then(function (
            data
          ) {
            $scope.localFilter.manager = data;
          });
        }

        function selectMunicipality() {
          MunicipalityService.select(
            $scope.localFilter.placeMunicipality
          ).result.then(function (data) {
            $scope.localFilter.placeMunicipality = data;
          });
        }

        function selectCoordOrg() {
          OrgService.select($scope.localFilter.coordOrg).result.then(function (
            data
          ) {
            $scope.localFilter.coordOrg = data;
          });
        }

        function selectOiv() {
          OrgService.select($scope.localFilter.oiv, [
            `'project.oiv' EQ '1'`,
          ]).result.then(function (data) {
            $scope.localFilter.oiv = data;
          });
        }

        function apply() {
          $scope.updateScopeFilters(buildFilters());
          $scope.oldFilter = angular.copy($scope.localFilter);
          angular.copy($scope.localFilter, $scope.filter);
          $utils.openControlSidebar();
        }

        function cancel() {
          angular.copy($scope.oldFilter, $scope.localFilter);
          $utils.openControlSidebar();
        }

        function reset() {
          $scope.localFilter = {
            placeMunicipality: [],
          };
          $scope.oldFilter = angular.copy($scope.localFilter);
          $scope.filter = angular.copy($scope.localFilter);
          $scope.updateScopeFilters([]);
        }
      },
    ],
  };
}
